import { scrollIntoView } from '~/framework/utils/scroll';
import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Horizontal Tab Bar Container Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => mountHorizontalTabBarContainer(listeners))
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Horizontal Tab Bar Container Component', error);
        });

    return () => {
        unmountVerticalScrollCarousel(listeners);

        app.logger.debug('[DXA] Horizontal Tab Bar Container Component destroyed');
    };
}

function mountHorizontalTabBarContainer(listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) {
    const horizontalTabs = document.querySelectorAll<HTMLElement>('.horizontal-tab-buttons');

    for (const horizontalTab of horizontalTabs) {
        // eslint-disable-next-line @typescript-eslint/no-loop-func,unicorn/consistent-function-scoping
        const scrollTabIntoView = (event: Event) => {
            if (event.target instanceof Element) {
                scrollIntoView(event.target, {
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'nearest'
                });
            }
        };

        const tabs = horizontalTab.querySelectorAll<HTMLElement>('.nav-link');
        for (const tab of tabs) {
            tab.addEventListener('click', scrollTabIntoView);
            listeners.push([tab, 'click', scrollTabIntoView]);
        }
    }
}

function unmountVerticalScrollCarousel(listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}